import styles from "./styles.module.scss";

const ScrollContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.scroll_container}>{children}</div>;
};

const scroll_style = styles.scroll_container;

export { ScrollContainer, scroll_style };
